(function(){
  document.querySelectorAll('.sgc-tab').forEach(function(tab){
    tab.addEventListener('click',function(){
      document.querySelectorAll('.sgc-tab').forEach(function(t){t.classList.remove('active')});
      document.querySelectorAll('.sgc-panel').forEach(function(p){p.classList.remove('active')});
      tab.classList.add('active');
      document.getElementById('sgc-'+tab.dataset.panel).classList.add('active');
    });
  });
  function conv(s,toIn){return toIn?s.replace(/[\d.]+/g,function(n){return (parseFloat(n)/2.54).toFixed(1)}):s}
  document.querySelectorAll('.sgc-ubtn').forEach(function(btn){
    btn.addEventListener('click',function(){
      var toIn=btn.dataset.unit==='in';
      document.querySelectorAll('.sgc-ubtn').forEach(function(b){b.classList.remove('active')});
      btn.classList.add('active');
      document.querySelectorAll('.sgc-table td[data-cm]').forEach(function(td){td.textContent=conv(td.dataset.cm,toIn)});
    });
  });
})();